import { Home, History, Users, TrendingUp, Wallet, Settings as SettingsIcon } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useViewMode } from '@/lib/view-mode-context';
import { useHaptics } from '@/hooks/use-haptics';
import { sounds } from '@/lib/sounds';
import { useUserSettings } from '@/lib/user-settings-context';
import { cn } from '@/lib/utils';

export function NeonBottomNav() {
  const { isPublic, targetUserId } = useViewMode();
  const { light } = useHaptics();
  const { settings } = useUserSettings();

  const handleNavClick = () => {
    if (settings.extra_juice) {
      light();
      sounds.play('pop');
    }
  };

  const getPath = (base: string) => {
    if (!isPublic) return base;
    if (base === '/') return `/public/${targetUserId}`;
    return `/public/${targetUserId}${base}`;
  };

  const tabs = [
    { to: getPath('/'), icon: Home, label: 'Home' },
    { to: getPath('/sessions'), icon: History, label: 'Sessions' },
    { to: getPath('/players'), icon: Users, label: 'Players' },
    { to: getPath('/expenses'), icon: Wallet, label: 'Expenses' },
    { to: getPath('/statistics'), icon: TrendingUp, label: 'Stats' },
    ...(!isPublic ? [{ to: '/settings', icon: SettingsIcon, label: 'Settings' }] : []),
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden px-4 pb-6 pt-2 pointer-events-none">
      <div className="max-w-md mx-auto pointer-events-auto">
        <div className="glass-card flex items-center justify-around h-16 rounded-2xl border-white/10 shadow-2xl bg-neon-bg/60 backdrop-blur-3xl overflow-hidden">
          {tabs.map(({ to, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              onClick={handleNavClick}
              end={to === '/' || (isPublic && to === `/public/${targetUserId}`)}
              className={({ isActive }) => cn(
                "relative flex flex-col items-center justify-center gap-1 w-full h-full transition-all duration-300",
                isActive ? "text-neon-cyan scale-110" : "text-neon-muted"
              )}
            >
              {({ isActive }) => (
                <>
                  <Icon className={cn(
                    "h-5 w-5 transition-transform duration-300",
                    isActive && "fill-neon-cyan/10"
                  )} />
                  <span className="text-[9px] font-black uppercase tracking-tighter">{label}</span>
                  {isActive && (
                    <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-neon-cyan shadow-[0_0_10px_hsl(var(--neon-cyan))] rounded-full animate-pulse-glow" />
                  )}
                </>
              )}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}
